var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5088_4658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.32 8.58667L29.5633 5.19333C30.545 4.41 30.9117 3.13833 30.4967 1.95333C30.0817 0.766667 29.0033 0 27.75 0H12.25C10.9967 0 9.91833 0.766667 9.50333 1.95333C9.08833 3.13833 9.455 4.41167 10.4367 5.19333L14.68 8.58667C9.38667 12.6383 5 21.575 5 28.75C5 34.3483 7.96167 40 14.5833 40H25.8333C31.4883 40 35 35.6883 35 28.75C35 21.575 30.6133 12.6383 25.32 8.58667Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 7.5H11.25C10.56 7.5 10 8.06 10 8.75C10 9.44 10.56 10 11.25 10H28.75C29.44 10 30 9.44 30 8.75C30 8.06 29.44 7.5 28.75 7.5Z",
    fill: "#264653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10H13.0633C8.52167 14.475 5 22.32 5 28.75C5 34.3483 7.96167 40 14.5833 40H20V10ZM20 0H12.25C10.9967 0 9.91833 0.766667 9.50333 1.95333C9.08833 3.13833 9.455 4.41167 10.4367 5.19333L13.32 7.5H20V0Z",
    fill: "#121B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5H13.32H11.25C10.56 7.5 10 8.06 10 8.75C10 9.44 10.56 10 11.25 10H13.0633H20V7.5Z",
    fill: "#121B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 22.9167C14.685 22.9167 13.75 21.9817 13.75 20.8333C13.75 19.685 14.685 18.75 15.8333 18.75C16.9817 18.75 17.9167 19.685 17.9167 20.8333C17.9167 21.9817 16.9817 22.9167 15.8333 22.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 31.25C23.0185 31.25 22.0835 30.315 22.0835 29.1667C22.0835 28.0184 23.0185 27.0834 24.1668 27.0834C25.3152 27.0834 26.2502 28.0184 26.2502 29.1667C26.2502 30.315 25.3152 31.25 24.1668 31.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 18.75C14.685 18.75 13.75 19.685 13.75 20.8333C13.75 21.9817 14.685 22.9167 15.8333 22.9167V18.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1668 27.0834C23.0185 27.0834 22.0835 28.0184 22.0835 29.1667C22.0835 30.315 23.0185 31.25 24.1668 31.25V27.0834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2265 31.1C16.3882 30.7183 16.0182 29.7317 16.3999 28.8933L20.5665 19.7267C20.9465 18.89 21.9282 18.515 22.7732 18.8983C23.6115 19.28 23.9815 20.2667 23.5999 21.105L19.4332 30.2717C19.0565 31.105 18.0732 31.4833 17.2265 31.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0815 18.7483C21.4465 18.7483 20.8449 19.1133 20.5665 19.7266L16.3999 28.8933C16.0182 29.73 16.3882 30.7183 17.2265 31.1L22.7732 18.9C22.5482 18.7966 22.3132 18.7483 22.0815 18.7483Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5088_4658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/MoneyBag.e297c7ae743c571f669ac2c43a44c2e8.svg";
export { ForwardRef as ReactComponent };